<div class="component-main-container">
  <div class="header">
    <app-page-header parentTitle="{{ 'companies.companies-parent-label' | translate }}"
      pageTitle="{{ 'companies.companies-page-label' | translate }}">
    </app-page-header>
  </div>

  <!--Corpo do componente-->
  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <app-register-form></app-register-form>
        <div class="form-fields-box" [ngClass]="!register ? 'closed' : ''" [formGroup]="registerCompaniesForm">
          <h2 (click)="registerBox()">
            {{ "companies.form-register-label" | translate }}
          </h2>
          <hr [ngClass]="!register ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>{{ "companies.form-name" | translate }}</mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>
          </div>

          <div class="form-step">
            <div class="circle-number">2</div>
            <mat-form-field appearance="outline">
              <mat-label>CNPJ</mat-label>
              <input matInput formControlName="cnpj" mask="00.000.000/0000-00" />
            </mat-form-field>
          </div>

          @if (!registerLoading) {
          <button title="{{ 'companies.form-save-button' | translate }}" class="btn btn-success"
            [disabled]="registerCompaniesForm.invalid" (click)="registerCompanies()">
            {{ "companies.form-save-button" | translate }}
          </button>
          }
          @if (registerLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>

        <div class="form-fields-box" [ngClass]="!filter ? 'closed' : ''" [formGroup]="filterCompaniesForm">
          <h2 (click)="filterBox()">
            {{ "companies.form-filter-label" | translate }}
          </h2>
          <hr [ngClass]="!filter ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>{{ "companies.form-name" | translate }}</mat-label>
              <input matInput formControlName="search" />
            </mat-form-field>
          </div>

          @if (!filterLoading) {
          <button title="{{ 'companies.form-filter-button' | translate }}" class="btn btn-success"
            (click)="filterCompanies(null)">
            {{ "companies.form-filter-button" | translate }}
          </button>
          }
          @if (filterLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    <!-- Sessão tabela -->
    @if (paginationProperties.total) {
    <div class="col-lg-7 col-xl-8 col-sm-12">
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="true" [hasPDF]="true" (downloadCSV)="generateFileData(null, 'CSV')" [loadingData$]="fileLoading"
        (downloadPDF)="generateFileData(null, 'PDF')"></app-table-header>
      <div class="table-container  mt-2 mt-lg-3">
        <p-table [value]="ELEMENT_DATA" dataKey="id" [rows]="pageSize" [totalRecords]="length" [paginator]="true"
          (onPage)="pageChanged($event)" [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="name">{{ "companies.form-name" | translate }}</th>
              <th pSortableColumn="cnpj"> CNPJ</th>
              <th pSortableColumn="actions"> {{ "companies.actions-table" | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>{{row.name}}</td>
              <td>{{row.cnpj}}</td>
              <td>
                <p-button styleClass="btn-actions" (click)="updateGetter(row.id, row.name, row.cnpj)"
                  icon="pi pi-pen-to-square" [rounded]="true" />
                <!-- <button class="btn btn-success view">
                  <mat-icon class="component-svg-icon" svgIcon="bx-edit"></mat-icon>
                </button> -->
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    }
  </div>

  <!-- Componente de edição -->
  @if (editorController) {
  <div class="sidebar-edit" [formGroup]="updateForm">
    <mat-icon (click)="closeEditionSideBar()">clear</mat-icon>
    <h2>{{ "companies.form-edit-label" | translate }}</h2>
    <hr>
    <mat-form-field appearance="outline">
      <mat-label>{{ "companies.form-name" | translate }}</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>CNPJ</mat-label>
      <input matInput formControlName="cnpj" />
    </mat-form-field>
    @if (!updateLoading) {
    <button class="btn btn-success" (click)="updateCompany()">{{"companies.form-save-button" |
      translate}}</button>
    }
    @if (updateLoading) {
    <mat-spinner [diameter]="30"></mat-spinner>
    }
  </div>
  }
</div>